export var PropertyStatus;
(function (PropertyStatus) {
    PropertyStatus["NewBuilding"] = "NEW_BUILDING";
    PropertyStatus["OffThePlan"] = "OFF_THE_PLAN";
    PropertyStatus["VacantLand"] = "VACANT_LAND";
    PropertyStatus["Established"] = "ESTABLISHED";
})(PropertyStatus || (PropertyStatus = {}));
export var PropertyZoneType;
(function (PropertyZoneType) {
    PropertyZoneType["Residential"] = "RESIDENTIAL";
    PropertyZoneType["Commercial"] = "COMMERCIAL";
    PropertyZoneType["Rural"] = "RURAL";
    PropertyZoneType["Industrial"] = "INDUSTRIAL";
})(PropertyZoneType || (PropertyZoneType = {}));
export var PropertyType;
(function (PropertyType) {
    PropertyType["ApartmentUnitLessThan50M2"] = "APARTMENT_UNIT_LESS_THAN_50M2";
    PropertyType["ApartmentUnitMoreThan50M2"] = "APARTMENT_UNIT_MORE_THAN_50M2";
    PropertyType["ServicedApartment"] = "SERVICED_APARTMENT";
    PropertyType["Stuido"] = "STUDIO";
    PropertyType["StudentAccommodation"] = "STUDENT_ACCOMMODATION";
    PropertyType["WarehouseApartment"] = "WAREHOUSE_APARTMENT";
    PropertyType["Duplex"] = "DUPLEX";
    PropertyType["Villa"] = "VILLA";
    PropertyType["FullyDetachedHouse"] = "FULLY_DETACHED_HOUSE";
    PropertyType["KitHome"] = "KIT_HOME";
    PropertyType["MultiDwellingSingleTitle"] = "MULTI_DWELLING_SINGLE_TITLE";
    PropertyType["PropertyOver10HA"] = "PROPERTY_OVER_10_HA";
    PropertyType["SemiDetachedHouse"] = "SEMI_DETACHED_HOUSE";
    PropertyType["Terrace"] = "TERRACE";
    PropertyType["Townhouse"] = "TOWNHOUSE";
    PropertyType["Land"] = "LAND";
})(PropertyType || (PropertyType = {}));
export var PropertyEstimateBasis;
(function (PropertyEstimateBasis) {
    PropertyEstimateBasis["ApplicantEstimate"] = "APPLICANT_ESTIMATE";
    PropertyEstimateBasis["BankAssessment"] = "BANK_ASSESSMENT";
    PropertyEstimateBasis["CertifiedValuation"] = "CERTIFIED_VALUATION";
    PropertyEstimateBasis["ElectronicValuation"] = "ELECTRONIC_VALUATION";
    PropertyEstimateBasis["RatesNotice"] = "RATES_NOTICE";
    PropertyEstimateBasis["RPData"] = "RP_DATA";
    PropertyEstimateBasis["Valocity"] = "VALOCITY";
})(PropertyEstimateBasis || (PropertyEstimateBasis = {}));
//# sourceMappingURL=Properties.js.map